import React from 'react';
import { Grid } from '@mui/material';

const DRFTable = ({ children }) => (
  <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
    {children}
  </Grid>
);

export default DRFTable;
